import packageInfo from '../../package.json';

export default {
  version_pwa: packageInfo.version,
};
